export type {
  GradientColor,
  GradientColors,
  GradientLocations,
  GradientPoint,
  GradientProps,
  GradientRenderer,
  GradientRendererProps,
  GradientRendererProviderProps,
} from '../../types/gradient';
export { Gradient } from './adapters/inbound/Gradient';
export { GradientRendererProvider } from './adapters/inbound/GradientRendererContext';
